<template>
    <keep-alive>
        <component v-bind:is="currentForm"></component>
    </keep-alive>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FormDocNumber from './FormDocNumber';
import FormPromoCode from './FormPromoCode';
import FormContacts from './FormContacts';
import FormSendCode from './FormSendCode';
import FakeLoading from './FakeLoading';

export default {
    components: {
        "form-doc-number": FormDocNumber,
        "form-promo-code": FormPromoCode,
        "form-contacts": FormContacts,
        "form-send-code":FormSendCode,
        "fake-loading":FakeLoading,
    },

    data: () => ({
        
    }),

    async created() {
        await this.ActionDoRegisterSession();
        
        // localStorage.clear();
    },

    computed: {
        ...mapState('auth', ['currentForm'])
    },

    methods: {
        ...mapActions('auth', ['ActionDoRegisterSession']),
    },
}
</script>
